var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showHeader)?_c('the-header'):_vm._e(),_c('the-sidebar'),_c('v-content',[_c('v-container',{class:{ 'container-without-padding': !_vm.showHeader },attrs:{"fluid":""}},[_c('div',{staticClass:"container-flud"},[_c('router-view')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }